import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setUserInfo } from '../redux/supportportalLoginSlice';
import Logo from '../static/image/logo.png';
import { decodedJWTPayload } from '../utils/commonUtil';

function TopNav() {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.supportportalLogin.userInfo);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token && !userInfo) {
      try {
        const userData = decodedJWTPayload(token);
        dispatch(setUserInfo(userData));
      } catch (error) {
        console.error('Failed to decode token:', error);
      }
    }
  }, [dispatch, userInfo]);

  return (
    <div
      className="top-nav"
      style={{
        backgroundColor: '#ED1A3D',
        height: '50px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 20px'
      }}
    >
      <img style={{ height: '30px' }} src={Logo} alt='' />
      {userInfo?.dn && (
        <div style={{ color: 'white', display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '10px' }}>Welcome</span>
          <span style={{ fontWeight: 'bold' }}>{userInfo.dn}</span>
        </div>
      )}
    </div>
  );
}

export default TopNav;
